import { gql } from "@apollo/client";

export const INSURANCE_CARRIERS = gql`
  query Query($carrierInput: CarrierInput) {
    insuranceCarrier(carrierInput: $carrierInput) {
      Carrier {
        carrier_id
        name
        usernameFieldPlaceholder
        thirdFieldPlaceholder
        color
        homepageUrl
        createAccountUrl
        resetPasswordUrl
        disablePasswordField
      }
    }
  }
`;

export const FETCH_INSURANCE = gql`
  query Query($fetchInsuranceInput: FetchInsuranceInput!) {
    fetchInsuranceRecord(fetchInsuranceInput: $fetchInsuranceInput) {
      total
      errors {
        type
        code
        message
      }
      customers {
        surveyResponse {
          question
          answer
        }
        videoResponse {
          title
          watched_secs
          total_secs
          last_watched_secs
        }
        reviewResponse {
          answer
          message
          review_question
          isReview
        }
        referralResponse {
          name
          mobile_number
          referral_question
        }
        appointmentResponse {
          preference
          time
          date
        }
        dealership {
          city
          street
          zipcode
          number
          state
        }
        agentDetail {
          full_name
          full_address
          agency_name
          email
          phone_number
        }
        requestQuote {
          customerStatus
          customerStatusId
          linesWritten
        }
        customer {
          date
          user_id
          last_name
          first_name
          mfa_preference
          carrier_password
          carrier_userid
          insurance_carrier
          third_field
          watched_artifacts
        }
        contact {
          address
          email
          mobile_number
        }
        employee {
          employee_user_id
          employee_lastname
          employee_firstname
          mobile_number
          email
        }
        questionnaire {
          question
          options
        }
        vehicles {
          year
          make
          model
          vehicle_status_id
          vin
        }
        vehicleTransactionResponse {
          vehicle_type
          transaction_type
          year
          make
          model
        }
        insuranceList {
          policy {
            policy_number
            policy_begin
            policy_end
            collision_deductible
            comp_deductible
            carrier_name
            is_cancelled
            total_premium
            is_issue
            created_at
          }
          documents {
            document_name
            document_url
          }
        }
        isAppsDownloaded
      }
    }
  }
`;
export const FETCH_EMPLOYEE_DEALERSHIPS = gql`
  query FetchEmployeeDealerships($employee_code: String!) {
    fetchEmployeeDealerships(employee_code: $employee_code) {
      dealerships {
        dealership_id
        dealership_name
        dealership_code
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const CSI_REPORT = gql`
  query CsiReport($reportInput: CsiReportInput!) {
    csiReport(reportInput: $reportInput) {
      summary {
        deliveries
        initialYes
        initialNo
        followUpYes
        followUpNo
        csiImproved
        csiDeclined
      }
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        initialCsi
        followUpCsi
        followUpDate
      }
      total
      errors {
        type
        code
        message
      }
    }
  }
`;
 export const SERVICE_APPOINTMENTS_REPORT = gql`
  query ServiceAppointmentsReport($reportInput: ServiceAppointmentsReportInput!) {
    serviceAppointmentsReport(reportInput: $reportInput) {
      summary {
        deliveries
        appointmentsCreated
        atDelivery
        followUpGenerated
      }
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        vehicles {
          year
          make
          model
          type
          status
          source
          setDate
          apptDate
          apptTime
          method
        }
      }
      total
      errors {
        type
        code
        message
      }
    }
  }
`;
 export const KNOWLEDGE_HUB_REPORT = gql`
  query KnowledgeHubReport($reportInput: KnowledgeHubReportInput!) {
    knowledgeHubReport(reportInput: $reportInput) {
      summary {
        deliveries
        knowledgeHubStarted
        experienceCompleted
        educationVideosViewed
        surveyQuestionsAnswered
        warrantyModuleInteractions
      }
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        vehicleType
        paymentType
        launchMethod
        started
        completed
        educationVideos
        surveyQuestions
        warrantyModule
      }
      total
      errors {
        type
        code
        message
      }
    }
  }
`;
 export const REVIEWS_REPORT = gql`
  query ReviewsReport($reportInput: ReviewsReportInput!) {
    reviewsReport(reportInput: $reportInput) {
      summary {
        deliveries
        reviewsAtDelivery
        reviewsFollowUp
        totalReviews
        reviewRate
      }
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        reviewAtDelivery
        followUpDate
        reviewFollowUp
      }
      total
      errors {
        type
        code
        message
      }
    }
  }
`;
 export const REFERRALS_REPORT = gql`
  query ReferralsReport($reportInput: ReferralsReportInput!) {
    referralsReport(reportInput: $reportInput) {
      summary {
        deliveries
        referralsAtDelivery
        referralsFollowUp
        totalReferrals
        referralRate
      }
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        deliveryReferral
        followUpDate
        followUpReferral
        referralCount
        referrals {
          name
          mobile_number
        }
      }
      total
      errors {
        type
        code
        message
      }
    }
  }
`;
 
export const INSURANCE_REPORT = gql`
  query InsuranceReport($reportInput: InsuranceReportInput!) {
    insuranceReport(reportInput: $reportInput) {
      summary {
        deliveries
        verifications
        initialAlerts
        followUpVerifications
        followUpAlerts
        totalVerifications
      }
 
      rows {
        purchaseDate
        customer
        cell
        email
        sales
        verified
        insAlert
        purchasedVehicleYMM
        otherVehicles {
          ymm
          vin
          isPurchased
        }
        followUpDate
        followUpInsAlert
      }
 
      total
 
      errors {
        type
        code
        message
      }
    }
  }
`;
export const FETCH_DEALERSHIP_EMPLOYEES = gql`
  query FetchDealershipEmployees($employeeListInput: EmployeeListInput!) {
    fetchDealershipEmployees(employeeListInput: $employeeListInput) {
      employees {
        employee_user_id
        first_name
        last_name
        employee_code
        is_active
      }
      errors {
        type
        code
        message
      }
    }
  }
`;
export const GET_CALL_COUNT = gql`
  query MyQuery($callInput: CallInput!) {
    getEmployeeTarget(callInput: $callInput) {
      dealership_id
      employee {
        employee_user_id
        role
        first_name
        last_name
        email
        mobile_number
        previous_target
        assigned_target
        completed
        status
        percentage
        quotes_requested
        requested_percentage
        notification_preference
        verification_preference
        appointment_preference
        review_preference
        referral_preference
        knowledge_hub_preference
        csi_preference
        prequal_preference
        id_verification_preference
        app_download_preference
        premiums_verified
        premiums_req_quote
        premiums_captured
        customers_captured
        lines_written
        is_active
        verification_workflow_id
        review_provided
        referral_provided
        appointment_set
        apps_downloaded
        satisfied_yes
        satisfied_no
        watched_artifacts
        verified_followup     
        review_followup       
        referral_followup      
        appointment_followup   
        satisfied_yes_followup
       satisfied_no_followup
        employee_code
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const PULL_INSURANCE = gql`
  query Query($pullInput: PullInput!) {
    pullInsurance(pullInput: $pullInput) {
      userId
      success
      premium
      isPolicyAvailable
      totalPremiumCents
      claims
      insurance_id
      errors {
        code
        type
        message
      }
    }
  }
`;

export const FETCH_TRADE_VEHICLE = gql`
  query query($tradeInput: TradeInput!) {
    fetchTradeVehicle(tradeInput: $tradeInput) {
      vehicle {
        vehicle_id
        vin
        year
        make
        model
        series
        vehicle_status_id
      }
    }
  }
`;
export const FETCH_DEALERSHIP_BRAND = gql`
  query FetchDealershipBrand($filterInput: FilterInput!) {
    getDealerships(filterInput: $filterInput) {
      dealerships {
        dealership_id
        brand_name
      }
      errors {
        code
        type
        message
      }
    }
  }
`;
export const GET_DEALERSHIPS = gql`
  query MyQuery($filterInput: FilterInput!) {
    getDealerships(filterInput: $filterInput) {
      dealerships {
        dealership_id
        dealership_code
        city
        email
        phone_number
        full_name
        brand_name
        is_active
        logo_url
        number
        state
        street
        zipcode
        percentage
        logout_time
        referral_notification_id
        crm_user_status
        follow_up_days
        verification_followup
        csi_followup
        csi_followup_days
        service_maintenance_followup
        service_maintenance_followup_1
        service_maintenance_followup_2
        service_maintenance_followup_3
        sales_aids
        is_warranty
        has_warranty_coverages
        warrantyCoverages {
          id
          warranty_vehicle_type_id
          warranty_classification_id
          warranty_type_en
          warranty_type_es
          coverage_months
          coverage_miles
          is_enabled
          info_title_en
          info_title_es
          info_subtitle_en
          info_subtitle_es
          info_footer_en
          info_footer_es
          information_items {
            id
            coverage_category_en
            coverage_category_es
            coverage_items_en
            coverage_items_es
          }
        }
        warrantyExclusions {
          id
          warranty_vehicle_type_id
          uncoverage_type
          exclusion_category_en
          exclusion_category_es
          exclusion_items_en
          exclusion_items_es
          title_en
          title_es
          footer_en
          footer_es
          columns {
            id
            column_header_en
            column_header_es
            column_items_en
            column_items_es
            sort_order
          }
        }

        dealershipTiming {
          id
          day
          isclosed
          opens_at
          closes_at
        }
        subscriptions {
          cost
          date
          feature_name
          is_active
          limit
          overage_cost
          payload
          totalCount
          quote_cost
        }
        main_contact {
          first_name
          last_name
          email
          phone_number
        }
        textArtifact {
          id
          text
          es_text
          position
        }
        surveyArtifact {
          id
          position
          question
          es_question
          options
          es_options
        }
        videoArtifact {
          id
          url
          es_url
          title
          es_title
          position
        }
        reviewUrl {
          id
          dealer_rater
          google
          message
          es_message
          facebook
          position
          referral_question
          es_referral_question
          review_question
          es_review_question
          second_review_question
          es_second_review_question
        }
        dealerAppUrl {
          id
          appstore
          playstore
          message
          es_message
          position
        }
        appointment {
          id
          preference_options
          es_preference_options
          message
          es_message
          position
        }
        ServiceMaintenanceArtifact {
          id
          followup_message_1
          es_followup_message_1
          followup_message_2
          es_followup_message_2
          followup_message_3
          es_followup_message_3
        }
        walkthroughVideo {
          id
          video_url
          es_video_url
          knowledgehub_video_url
          es_knowledgehub_video_url
          text
          es_text
          knowledgehub_text
          es_knowledgehub_text
        }
        serviceId {
          id
          service_id
          service_text
          es_service_text
          is_active
          provider_id
        }
        tradeArtifact {
          id
          text
          es_text
        }
        quoteArtifact {
          id
          text
          es_text
          quote_options
          es_quote_options
          quote_question
          es_quote_question
        }
        avatar {
          id
          avatar_id
          voice_id
        }
        vehicleTransactionArtifact {
          id
          vehicle_information
          es_vehicle_information
          vehicle_message
          es_vehicle_message
          vehicle_options
          es_vehicle_options
          transaction_message
          es_transaction_message
          transaction_options
          es_transaction_options
          position
        }
        warrantyArtifact {
          id
          warranty_message
          is_enabled
          warranty_es_message
          position
          ai_url {
            english_url
            spanish_url
          }
        }
        displayRules {
          id
          artifact_type_id
          artifact_id
          vehicle_rules
          transaction_rules
        }
      }
      errors {
        code
        message
        type
      }
    }
  }
`;

export const DEALERSHIP_BILLING = gql`
  query MyQuery($billingInput: BillingInput!) {
    dealershipBilling(billingInput: $billingInput) {
      dealership_id
      billing {
        limit
        is_active
        feature_name
        date
        cost
        payload
        overage_cost
        totalCount
        totalRequestCount
        quote_cost
      }
      errors {
        code
        type
        message
      }
    }
  }
`;
export const FETCH_MAKES = gql`
  query FetchMakes($year: String) {
    fetchMakes(year: $year) {
      yearArray
      makeArray
      modelArray
      trimArray
    }
  }
`;

export const FETCH_VERIFICATION_URL = gql`
  query query($verificationInput: VerificationInput!) {
    fetchVerificationUrl(verificationInput: $verificationInput) {
      verification_url
      userId
      percentage
      verification_workflow_id
      image_url
      walkthrough_video {
        video_url
        es_video_url
        text
        es_text
        knowledgehub_video_url
        es_knowledgehub_video_url
        knowledgehub_text
        es_knowledgehub_text
      }
      dealershipTiming {
        id
        day
        isclosed
        opens_at
        closes_at
      }
      dealershipServices {
        service_id
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const TRANSACTION_HISTORY = gql`
  query MyQuery($transactionInput: TransactionInput!) {
    fetchTransactions(transactionInput: $transactionInput) {
      timestamp
      status
      pullId
      payload {
        output_payload
        created_at
      }
      employeeName
      dealershipName
      customer {
        contactNumber
        email
        fullName
        vin
      }
    }
  }
`;
export const SEARCH_MANAGER = gql`
  query MyQuery($searchInput: SearchInput) {
    searchManager(searchInput: $searchInput) {
      removeExistingEmail
      getAllEmails
      filterAllEmails
      filterExistingEmail
      errors {
        code
        type
        message
      }
    }
  }
`;

export const FETCH_YMMT = gql`
  query query($ymmtInput: YmmtInput) {
    fetchYmmt(ymmtInput: $ymmtInput) {
      yearArray
      modelArray
      makeArray
      trimArray
    }
  }
`;

export const SEARCH_PATNERS = gql`
  query query($selectedInput: SelectedInput) {
    searchPatners(selectedInput: $selectedInput) {
      getAllPatners
      getPatnerId
      errors {
        code
        type
        message
      }
    }
  }
`;

export const FETCH_API_TRANSACTION = gql`
  query query($apiFetchInput: ApiFetchInput) {
    apifetchTransaction(apiFetchInput: $apiFetchInput) {
      employee_user_id
      dealership_id
      data
      workflowId
      first_name
      last_name
      image_url
      dealership_name
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_QUESTIONNAIRE = gql`
  query query($questionnaireInput: QuestionnaireInput) {
    fetchQuestionnaire(questionnaireInput: $questionnaireInput) {
      questionsArray {
        question
        es_question
        options
        es_options
        id
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_ARTIFACTS = gql`
  query query($fetchInput: FetchInput!) {
    fetchArtifacts(fetchInput: $fetchInput) {
      dealership_id
      isArtifact
      is_warranty
      has_warranty_coverages
      text {
        id
        text
        es_text
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      survey {
        id
        question
        es_question
        es_options
        options
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      video {
        id
        title
        es_title
        url
        es_url
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      review {
        id
        message
        es_message
        google
        facebook
        dealer_rater
        position
        referral_question
        es_referral_question
        review_question
        es_review_question
        second_review_question
        es_second_review_question
        review_ai_url {
          english_url
          spanish_url
        }
        second_review_ai_url {
          english_url
          spanish_url
        }
        rating_ai_url {
          english_url
          spanish_url
        }
        referral_ai_url {
          english_url
          spanish_url
        }
      }
      dealer_app {
        id
        message
        es_message
        playstore
        appstore
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      appointment {
        id
        position
        message
        es_message
        preference_options
        es_preference_options
        ai_url {
          english_url
          spanish_url
        }
      }
      ServiceMaintenanceArtifact {
        id
        followup_message_1
        es_followup_message_1
        followup_message_2
        es_followup_message_2
        followup_message_3
        es_followup_message_3
        ai_url {
          english_url
          spanish_url
        }
      }
      service {
        id
        service_id
        service_text
        es_service_text
        ai_url {
          english_url
          spanish_url
        }
      }
      tradeArtifact {
        id
        text
        es_text
        ai_url {
          english_url
          spanish_url
        }
      }
      quoteArtifact {
        id
        text
        es_text
        quote_options
        es_quote_options
        quote_question
        es_quote_question
        quote_ai_url {
          english_url
          spanish_url
        }
        questionnaire_ai_url {
          english_url
          spanish_url
        }
      }
      surveyOther {
        id
        text
        avatar_id
        voice_id
        url
        language_id
      }
      vehicleTransactionArtifact {
        id
        vehicle_information
        es_vehicle_information
        vehicle_message
        es_vehicle_message
        vehicle_options
        es_vehicle_options
        transaction_message
        es_transaction_message
        transaction_options
        es_transaction_options
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      warrantyArtifact {
        id
        warranty_message
        warranty_es_message
        is_enabled
        position
        ai_url {
          english_url
          spanish_url
        }
      }
      displayRules {
        id
        artifact_type_id
        artifact_id
        vehicle_rules
        transaction_rules
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_WARRANTY_COVERAGES = gql`
  query FetchWarrantyCoverages($warrantyCoverageInput: WarrantyCoverageInput) {
    fetchWarrantyCoverages(warrantyCoverageInput: $warrantyCoverageInput) {
      coverages {
        id
        warranty_vehicle_type_id
        warranty_classification_id
        warranty_type_en
        warranty_type_es
        coverage_months
        coverage_miles
        info_description_en
        info_description_es
        info_title_en
        info_title_es
        info_subtitle_en
        info_subtitle_es
        is_enabled
        info_footer_en
        info_footer_es
        information_items {
          id
          coverage_category_en
          coverage_category_es
          coverage_items_en
          coverage_items_es
        }
      }
      exclusions {
        id
        warranty_vehicle_type_id
        uncoverage_type
        exclusion_category_en
        exclusion_category_es
        exclusion_items_en
        exclusion_items_es
        title_en
        title_es
        footer_en
        footer_es
        columns {
          id
          column_header_en
          column_header_es
          column_items_en
          column_items_es
          sort_order
        }
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_WARRANTY_RESPONSE = gql`
  query FetchWarrantyResponse(
    $warrantyResponseFetchInput: WarrantyResponseFetchInput
  ) {
    fetchWarrantyResponse(
      warrantyResponseFetchInput: $warrantyResponseFetchInput
    ) {
      response {
        id
        dealership_id
        user_id
        employee_user_id
        warranty_vehicle_id
        annual_mileage
        years_owned
        created_at
        items {
          id
          warranty_coverage_id
          covered_months
          uncovered_months
        }
      }
      coverages {
        id
        warranty_vehicle_type_id
        warranty_classification_id
        warranty_type_en
        warranty_type_es
        coverage_months
        coverage_miles
        info_description_en
        info_description_es
        info_title_en
        info_title_es
        info_subtitle_en
        info_subtitle_es
        is_enabled
        info_footer_en
        info_footer_es
        information_items {
          id
          coverage_category_en
          coverage_category_es
          coverage_items_en
          coverage_items_es
        }
      }
      exclusions {
        id
        warranty_vehicle_type_id
        uncoverage_type
        exclusion_category_en
        exclusion_category_es
        exclusion_items_en
        exclusion_items_es
        title_en
        title_es
        footer_en
        footer_es
        columns {
          id
          column_header_en
          column_header_es
          column_items_en
          column_items_es
          sort_order
        }
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_CUSTOMERS = gql`
  query query($fetchCustomerInput: FetchCustomerInput) {
    fetchCustomerDetails(fetchCustomerInput: $fetchCustomerInput) {
      first_name
      last_name
      mobile_number
      year
      make
      model
      vin
      email
      dealership_id
      employee_user_id
      carrier_password
      carrier_userid
      insurance_carrier
      mfa_preference
      third_field
      employee_name
      created_at
      userId
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_DOCUMENT = gql`
  query query($documentInput: DocumentInput!) {
    fetchDocument(documentInput: $documentInput) {
      payload {
        created_at
        insurance_id
        documents {
          document_name
          document_url
        }
      }
      errors {
        type
        code
        message
      }
    }
  }
`;
export const FETCH_REFERRAL_DETAILS = gql`
  query query($userId: Int!) {
    fetchReferralDetails(userId: $userId) {
      dealership_logo
      message
      review_question_id
      errors {
        type
        code
        message
      }
    }
  }
`;
export const FETCH_CSI_DETAILS = gql`
  query query($userId: Int!, $employeeUserId: Int!, $dealershipId: Int!) {
    fetchCsiDetails(
      userId: $userId
      employeeUserId: $employeeUserId
      dealershipId: $dealershipId
    ) {
      dealership_logo
      message
      second_review_question
      es_second_review_question
      review_question_id
      user_language_id
      second_review_ai_url {
        english_url
        spanish_url
        selected_url
      }
      errors {
        type
        code
        message
      }
    }
  }
`;
export const FETCH_SERVICE_DETAILS = gql`
  query FetchServiceDetails(
    $userId: Int!
    $employeeUserId: Int!
    $dealershipId: Int!
    $vehicleId: Int!
    $followupNumber: Int
  ) {
    fetchServiceDetails(
      userId: $userId
      employeeUserId: $employeeUserId
      dealershipId: $dealershipId
      vehicleId: $vehicleId
      followupNumber: $followupNumber
    ) {
      dealership_logo
      user_language_id
      service_artifact_id
      followup_message_1
      es_followup_message_1
      followup_message_2
      es_followup_message_2
      followup_message_3
      es_followup_message_3
      vehicle {
        vehicle_id
        year
        make
        model
      }
      service_ai_videos {
        english_url
        spanish_url
        selected_url
      }
      openingHours {
        id
        day
        isclosed
        opens_at
        closes_at
      }
      preference_options
      es_preference_options
      employee_first_name
      employee_phone
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_DEALERSHIP_DETAILS = gql`
  query query($dealershipId: Int!) {
    fetchDealershipDetails(dealershipId: $dealershipId) {
      isWalthrough
      errors {
        type
        code
        message
      }
    }
  }
`;

export const FETCH_AVATARS = gql`
  query query {
    fetchAvatars {
      avatars {
        avatar_id
        avatar_url
        gender
        id
        voice_id
        errors {
          type
          code
          message
        }
      }
    }
  }
`;

export const FETCH_SERVICES = gql`
  query query {
    fetchServices {
      dealershipServices {
        id
        service
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const CHECK_SERVICES = gql`
  query query($serviceInput: ServiceInput) {
    checkServices(serviceInput: $serviceInput) {
      isVerification
      isArtifacts
      errors {
        type
        code
        message
      }
    }
  }
`;
export const CUSTOMER_DIALOG = gql`
  query query($dialogInput: DialogInput) {
    customerDialog(dialogInput: $dialogInput) {
      appointment_preference
      insuranceService {
        policy_number
        policy_begin
        policy_end
        collision_deductible
        comp_deductible
        carrier_name
        is_cancelled
        total_premium
        is_issue
        created_at
        insurance_id
        vehicle {
          vin
          vehicle_id
          make
          make_year
          model
          vehicle_status_id
          created_at
        }
        quoteQuestions {
          question
          response
          created_at
          insurance_id
        }
      }
      quoteQuestions {
        question
        response
        created_at
        insurance_id
      }
      vehicle {
        vin
        vehicle_id
        make
        make_year
        model
        vehicle_status_id
        created_at
      }
      surveyResponse {
        question
        answer
        created_at
      }
      videoResponse {
        title
        watched_secs
        total_secs
        last_watched_secs
        created_at
      }
      reviewResponse {
        answer
        second_review_answer
        message
        review_question
        second_review_question
        isReview
        created_at
      }
      referralResponse {
        name
        mobile_number
        referral_question
        created_at
      }
      vehicleTransactionResponse {
        vehicle_type
        transaction_type
        year
        make
        model
        vehicle_status_id
      }
      vehicleAppointments {
        vehicle_id
        vin
        make
        make_year
        model
        vehicle_status_id
        appointment_set
        appointment_date
        appointment_time
        date
        time
        preference
        source
        created_at
      }
      errors {
        type
        code
        message
      }
    }
  }
`;

export const CONSENT_DATAS = gql`
  query query($verificationInput: VerificationInput!) {
    consentDatas(verificationInput: $verificationInput) {
      verification_url
      userId
      percentage
      verification_workflow_id
      image_url
      walkthrough_video {
        video_url
        es_video_url
        text
        es_text
        knowledgehub_video_url
        es_knowledgehub_video_url
        knowledgehub_text
        es_knowledgehub_text
      }
      dealershipTiming {
        id
        day
        isclosed
        opens_at
        closes_at
      }
      dealershipServices {
        service_id
      }
      errors {
        code
        type
        message
      }
    }
  }
`;
export const GROUP_DASHBOARD = gql`
  query query($groupDashboardInput: GroupDashboardInput!) {
    groupDashboard(groupDashboardInput: $groupDashboardInput) {
      groupDashboard {
        dealership_id
        dealership_name
        completed
        quotesRequested
        review_provided
        satisfied_yes
        satisfied_no
        referral_provided
        apps_downloaded
        appointment_set
        watchedArtifacs
        verified_followup      
        review_followup        
        referral_followup      
        appointment_followup  
        satisfied_yes_followup
        satisfied_no_followup
      }
      errors {
        code
        type
        message
      }
    }
  }
`;

export const POLL_CANOPY_STATUS = gql`
  query query($pull_id: String!) {
    pollCanopyStatus(pull_id: $pull_id) {
      pull_id
      status
      event_type
      data
    }
  }
`;
